import {
  AUTH_TYPES,
  ApiError,
  ApiErrorAction,
  LoginAction,
  LogoutAction,
  GetMeAction,
  GetMeSuccessAction,
  GetMeErrorAction,
  SetApiMeRequestStateAction,
  SetIsAuthenticatedAction,
} from './authTypes';
import { API_STATUS_CODE } from '../../enums/apiStatusCode';
import { MeGetResponse } from '../model/authModel';
import { API_REQUEST_STATE } from '../../enums/apiRequestState';

export const setIsAuthenticated = (isAuthenticated: boolean): SetIsAuthenticatedAction => ({
  type: AUTH_TYPES.SET_IS_AUTHENTICATED,
  payload: {
    isAuthenticated: isAuthenticated,
  },
});

export const setApiMeRequestState = (apiMeRequestState: API_REQUEST_STATE): SetApiMeRequestStateAction => ({
  type: AUTH_TYPES.SET_API_ME_REQUEST_STATE,
  payload: {
    apiMeRequestState: apiMeRequestState,
  },
});

export const apiError = (error: ApiError): ApiErrorAction => ({
  type: AUTH_TYPES.API_ERROR,
  payload: {
    errorCode: error?.response?.status ?? API_STATUS_CODE.SERVER_ERROR,
  },
});

export const login = (): LoginAction => ({
  type: AUTH_TYPES.LOGIN,
  payload: null,
});

export const logout = (): LogoutAction => ({
  type: AUTH_TYPES.LOGOUT,
  payload: null,
});

export const getMe = (): GetMeAction => ({
  type: AUTH_TYPES.GET_ME,
  payload: null,
});

export const getMeSuccess = (me: MeGetResponse): GetMeSuccessAction => ({
  type: AUTH_TYPES.GET_ME_SUCCESS,
  payload: {
    me: me,
  },
});

export const getMeError = (): GetMeErrorAction => ({
  type: AUTH_TYPES.GET_ME_ERROR,
  payload: null,
});
